import { useState, useEffect } from "react";

const useIsPJ = () => {
    const [isPJ, setIsPJ] = useState(false);

    useEffect(() => {
        const urlQuery = window.location.search;
        const urlParams = new URLSearchParams(urlQuery);

        if (urlParams.get('utm_campaign') === 'movel_site_pj_fatura_facil') {
            setIsPJ(true);
        }
    }, [setIsPJ]);

    return isPJ;
}

export default useIsPJ;
